import { createModelSelector, createSelector } from '@ngxs/store';
import { MatterClientIntakeFormState } from '@state/matter/client-intake/client-intake.state';
import { PortalInviteState } from '@state/portal-invite/portal-invite.state';
import { PortalInviteStatus } from '@models/portal-invites';
import { SelectedMatter } from '@state/matter/matter.selectors';
import { IntakeCTA } from './models';
import { IntakeFormClientResponsesSelectors } from '@domain/intake-form-client-responses';

export const $intakeCTA = createSelector(
	[
		MatterClientIntakeFormState.getMostRecentActiveForm,
		PortalInviteState.getInviteByPortalServiceId,
	],
	(intakeForm, getPortalInvite): IntakeCTA => {
		const portalInvite = getPortalInvite(intakeForm?.id);
		const intakeSectionCTA =
			portalInvite?.status === PortalInviteStatus.ACTIVE
				? { label: 'View Responses', leftIcon: 'file-text' }
				: { label: 'Start Request', rightIcon: 'chevron-right' };

		return intakeSectionCTA;
	},
);

export const $intakeActionsViewModel = createModelSelector({
	matterId: SelectedMatter.id,
	currentIntakeForm: MatterClientIntakeFormState.getMostRecentActiveForm,
	currentPortalInvite: PortalInviteState.getInviteByPortalServiceId,
	intakeFormResponses: IntakeFormClientResponsesSelectors.$intakeFormResponses,
	intakeResponseStatusCounts:
		IntakeFormClientResponsesSelectors.$intakeResponseStatusCounts,
	intakeCTA: $intakeCTA,
});
